var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.43276 29.3928C4.92446 27.8263 4.92446 24.1737 7.43276 22.6072L11.7241 19.9273C12.8526 19.2225 13.5569 18.0028 13.6029 16.6731L13.7782 11.6167C13.8806 8.66121 17.0439 6.83489 19.6546 8.22392L24.1212 10.6004C25.2958 11.2253 26.7042 11.2253 27.8788 10.6004L32.3454 8.22392C34.9561 6.83488 38.1194 8.66121 38.2218 11.6167L38.3971 16.6731C38.4431 18.0028 39.1474 19.2225 40.2759 19.9273L44.5672 22.6072C47.0755 24.1737 47.0755 27.8263 44.5672 29.3928L40.2759 32.0727C39.1474 32.7775 38.4431 33.9972 38.3971 35.3269L38.2218 40.3833C38.1194 43.3388 34.9561 45.1651 32.3454 43.7761L27.8788 41.3996C26.7042 40.7747 25.2958 40.7747 24.1212 41.3996L19.6546 43.7761C17.0439 45.1651 13.8806 43.3388 13.7782 40.3833L13.6029 35.3269C13.5569 33.9972 12.8526 32.7775 11.7241 32.0727L7.43276 29.3928Z",
    stroke: "#FCFCFC",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 6,
    stroke: "#FCFCFC",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.09e99e873de05aa85ea70b11230ca304.svg";
export { ForwardRef as ReactComponent };